import { useDispatch } from 'react-redux'
import { useCallback } from 'react'
import { UpdateSimpleFieldPayload, actions } from 'builder/modules/resumeEditor'

const useUpdateSimpleField = () => {
  const dispatch = useDispatch()

  const updateSimpleField = useCallback(
    ({ debounce = true, ...rest }: UpdateSimpleFieldPayload) => {
      dispatch(actions.updateSimpleField({ ...rest, debounce }))
    },
    [dispatch],
  )

  return { updateSimpleField }
}

export { useUpdateSimpleField }
